import { FileExcelOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContext from "../../context/app/context";
import CityContext from "../../context/city/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import CityContextProvider from "../../context/city/provider";
import CityTable from "../../components/city/city-table";
import SearchFilterCard from "../../components/general/filter-card";
import Can from "../../utils/rbac/can";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import FormHookModal from "../../components/general/modals/form-hook-modal";
import { useModal } from "react-modal-hook";
import ExportToExcelModal from "../../components/general/excel/export-to-excel-modal";
import TemplateExportExcel from "../../components/general/excel/expor-excel";
import {
  IExportCityExcel,
  columnsExportCityExcel,
} from "../../models/city/request";
interface IProps {
  children?: React.ReactNode;
}

// sum array in js
const JopTile: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const [exportModalVisible, setExportModalVisible] = useState(false);
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(CityContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);

  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("cities")}
        subTitle={t("cities_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
            <Button
              type="primary"
              onClick={() => {
                navigate(`/cities/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_city")}
            </Button>
          </Can>,
          // <Divider key={1} type="vertical" />,

          // <Button
          //   type="primary"
          //   onClick={() => {
          //     setExportModalVisible(true);
          //   }}
          //   icon={<FileExcelOutlined />}
          // >
          //   {t("export_to_excel")}
          // </Button>,
        ]}
      />
      <SearchFilterCard
        formId="city-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        {/* <FormProvider {...filterMethods}>
          <UserFilter />
        </FormProvider> */}
      </SearchFilterCard>

      {/* <Outlet /> */}
      <CityTable />
      <ExportToExcelModal
        id="export-category"
        title={t("export_to_excel")}
        visible={exportModalVisible}
        toggleVisible={setExportModalVisible}
        width="50vw"
        defaultValues={
          {
            id: false,
            name: false,
            note: false,
          } as IExportCityExcel
        }
        loading={loading.includes("create")}
        onSubmit={async (columnsNames) => {
          // await a(columnsNames);
          await actions.exportExcel(columnsNames);
          setExportModalVisible(false);
        }}
      >
        <TemplateExportExcel names={columnsExportCityExcel} />
      </ExportToExcelModal>
    </div>
  );
};

const CityPage = () => {
  return (
    // ContextProvider
    <CityContextProvider>
      <JopTile />
    </CityContextProvider>
  );
};
export default CityPage;
